import { useState } from "react";

export const useTableFileFilters = () => {
  const [statusFilter, setStatusFilter] = useState<string | null>(null);
  const [failureType, setFailureType] = useState<string | null>(null);
  const [filePathFilter, setFilePathFilter] = useState<string | null>("");
  const [destinationPathFilter, setDestinationPathFilter] = useState<string | null>("");
  const [minSizeFilter, setMinSizeFilter] = useState<number | null>(null);
  const [maxSizeFilter, setMaxSizeFilter] = useState<number | null>(null);
  const [extensions, setExtensions] = useState<string[]>([]);
  const [extensionsSearch, setExtensionsSearch] = useState<string[]>([]);

  const handleDestinationPathSearch = (destinationPath: string) => {
    setDestinationPathFilter(destinationPath);
  };

  const handleFilePathSearch = (filePath: string) => {
    setFilePathFilter(filePath);
  };

  const handleMaxSizeFilter = (size: string) => {
    const maxSize = parseToNumberOrNull(size);
    setMaxSizeFilter(maxSize);
  };

  const handleMinSizeFilter = (size: string) => {
    const minSize = parseToNumberOrNull(size);
    setMinSizeFilter(minSize);
  };

  const parseToNumberOrNull = (value: string) => {
    return value !== "" && value !== null ? Number(value) : null;
  };

  return {
    statusFilter,
    failureType,
    filePathFilter,
    destinationPathFilter,
    minSizeFilter,
    maxSizeFilter,
    extensions,
    extensionsSearch,
    setStatusFilter,
    setFailureType,
    setFilePathFilter,
    setDestinationPathFilter,
    setMinSizeFilter,
    setMaxSizeFilter,
    setExtensions,
    setExtensionsSearch,
    handleDestinationPathSearch,
    handleFilePathSearch,
    handleMaxSizeFilter,
    handleMinSizeFilter
  };
};